import { z } from 'zod'

export const ADMINSOLOSESSIONSGET_CONTRACT_VERSION = '1.0.0' as const
export const adminSoloSessionsGetResponseSchema = z.unknown()
export type AdminSoloSessionsGetResponse = z.infer<typeof adminSoloSessionsGetResponseSchema>
